import * as React from "react";
import CreateService from "../../../service/create";
import ReadService from "../../../service/read";
import SecondLayer from "../../container/second_layer";
import ProjectListPane from "./project_list";
import {ProjectsService} from "../../../service/v1/projects";
import PopDetail from "../../popdetail";
import AddNewProjectPane from "./add_new_project_pane";
import MonitoringEvaluationListPane from "./monitoring_evaluation_list";

export default class ProjectInfoPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            station: {},
            info: {
                localities: [],
                funders: [],
            }
        }
        this.fetchProjectInfo = this.fetchProjectInfo.bind(this)

    }

    componentDidMount() {
        this.fetchProjectInfo()
    }

    fetchProjectInfo() {
        try {
            ProjectsService.fetchProjectInfo(this.props.project.id).then(d => {
                try {
                    console.log(d.data)
                    this.setState({
                        info: d.data.results
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }

    approveProject(action) {
        try {
            ProjectsService.remarkProject({
                action: action,
                remarks: 'Project was ' + action,
                status_code: action,
                task_id: '',
                screen_code: '',
            }, this.props.project.id).then(r => {
                SecondLayer.dismiss()
                if (this.props.project.project_type_info.name.toLowerCase().includes("monitoring")){
                    MonitoringEvaluationListPane.loadData()
                } else {
                    ProjectListPane.loadData()
                }
            })
        } catch (e) {
            console.log(e)
        }
    }

    rejectProject(action, reason) {
        try {
            ProjectsService.remarkProject({
                action: action,
                remarks: 'Project was ' + action + ' : ' + reason,
                status_code: action,
                task_id: '',
                screen_code: '',
            }, this.props.project.id).then(r => {
                PopDetail.dismiss()
                ProjectListPane.loadData()
                this.fetchProjectInfo()
            })
        } catch (e) {
            console.log(e)
        }
    }

    render() {
        console.log("GGGG")
        console.log(sessionStorage.getItem('user_groups'))
        
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        
        const container = {
            width: '100%',
            minHeight: '100vh',
            background: '#f6f8fa',
            fontFamily,
            padding: '0 24px 24px 24px'
        };
        
        const header = {
            padding: '18px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: 20,
            fontWeight: 700,
            color: '#395d9a',
            fontFamily,
            borderBottom: '1px solid #e0e7ef',
            marginBottom: '24px'
        };
        
        const actionButtons = {
            display: 'flex',
            gap: 12,
            marginBottom: 24
        };
        
        const approveBtn = {
            background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
            color: 'white',
            border: 'none',
            borderRadius: 8,
            padding: '10px 24px',
            fontWeight: 600,
            fontSize: 15,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 8
        };
        
        const rejectBtn = {
            background: '#e74c3c',
            color: 'white',
            border: 'none',
            borderRadius: 8,
            padding: '10px 24px',
            fontWeight: 600,
            fontSize: 15,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 8
        };
        
        const infoGrid = {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: 16,
            marginBottom: 24
        };
        
        const infoCard = {
            background: '#fff',
            borderRadius: 14,
            boxShadow: '0 4px 12px rgba(57,93,154,0.12), 0 2px 4px rgba(57,93,154,0.08)',
            padding: '16px',
            fontFamily,
            transition: 'transform 0.2s, box-shadow 0.2s',
            border: '1px solid rgba(57,93,154,0.05)'
        };
        
        const cardHeader = {
            fontSize: 16,
            fontWeight: 600,
            color: '#395d9a',
            marginBottom: 14,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            paddingBottom: 8,
            borderBottom: '2px solid #f0f0f0'
        };
        
        const infoRow = {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px 0',
            borderBottom: '1px solid #f8f9fa',
            transition: 'background-color 0.2s'
        };
        
        const infoLabel = {
            fontSize: 14,
            fontWeight: 500,
            color: '#666',
            minWidth: '100px',
            display: 'flex',
            alignItems: 'center',
            gap: 4
        };
        
        const infoValue = {
            fontSize: 14,
            fontWeight: 400,
            color: '#333',
            textAlign: 'right',
            flex: 1,
            paddingLeft: 8
        };
        
        const listItem = {
            padding: '8px 0',
            fontSize: 14,
            color: '#333',
            borderBottom: '1px solid #f8f9fa',
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            transition: 'background-color 0.2s'
        };
        
        const commentsCard = {
            background: '#fff',
            borderRadius: 14,
            boxShadow: '0 4px 12px rgba(57,93,154,0.12), 0 2px 4px rgba(57,93,154,0.08)',
            padding: '16px',
            fontFamily,
            border: '1px solid rgba(57,93,154,0.05)'
        };
        
        const commentsTextarea = {
            width: '100%',
            minHeight: '100px',
            padding: '12px',
            border: '1px solid #e0e7ef',
            borderRadius: 12,
            fontSize: 14,
            fontFamily,
            resize: 'vertical',
            backgroundColor: this.state.info.status === 'Rejected' ? '#ffebee' : 
                           this.state.info.status === 'Approved' ? '#e8f5e9' : 
                           '#ffffff',
            transition: 'border-color 0.2s, box-shadow 0.2s'
        };
        
        const statusBadge = {
            padding: '4px 10px',
            borderRadius: 12,
            fontSize: 12,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
        };
        
        const emptyState = {
            textAlign: 'center',
            color: '#999',
            fontSize: 14,
            fontStyle: 'italic',
            padding: '12px 0'
        };
        
        return (
            <div style={container}>
                <div style={header}>
                    <span>
                        <span className={'fa fa-info'} style={{marginRight: 12}}/>
                         {this.state.info.name}
                    </span>
                </div>
                
                {(sessionStorage.getItem('user_groups') === 'SUPERVISOR' || sessionStorage.getItem('user_groups') === 'ADMIN') &&
                 this.state.info.status !== 'Approved' && this.state.info.status !== 'Rejected' && (
                    <div style={actionButtons}>
                        <button onClick={() => this.approveProject('approved')} style={approveBtn}>
                            <span className={'fa fa-check'}/>Approve
                        </button>
                        <button onClick={() =>
                            PopDetail.showDynamic('Project Rejection', 
                                <div style={{textAlign:'center',padding:'16px'}}>
                                    <h4 style={{fontSize: '18px', marginBottom: '16px'}}>Please provide a reason for rejection:</h4>
                                    <hr/>
                                    <textarea 
                                        name={'reason'} 
                                        style={{
                                            width: '100%', 
                                            padding: '12px',
                                            minHeight: '150px',
                                            fontSize: '16px',
                                            lineHeight: '1.5',
                                            resize: 'vertical',
                                            fontFamily: 'inherit'
                                        }} 
                                        placeholder="Enter rejection reason..."
                                    />
                                    <div style={{marginTop: '20px'}}>
                                        <button onClick={() => {
                                            const reason = document.querySelector('textarea[name="reason"]').value;
                                            if (reason.trim()) {
                                                this.rejectProject('rejected', reason);
                                            } else {
                                                alert('Please provide a reason for rejection');
                                            }
                                        }} className={'submit'}>Submit</button>
                                        <button onClick={() => PopDetail.dismiss()} style={{marginLeft: '8px'}}>Cancel</button>
                                    </div>
                                </div>, 
                                50,
                                50
                            )
                        } style={rejectBtn}>
                            <span className={'fa fa-times'}/>Reject
                        </button>
                    </div>
                )}

                <div style={infoGrid}>
                    <div style={infoCard}>
                        <div style={cardHeader}>
                            <span className={'fa fa-cog'} style={{color: '#395d9a'}}/>Project Details
                        </div>
                        <div style={infoRow}>
                            <span style={infoLabel}>
                                <span className={'fa fa-tag'} style={{color: '#666', fontSize: 12}}/>
                                Project Type
                            </span>
                            <span style={infoValue}>{this.state.info.type || 'Not specified'}</span>
                        </div>
                        <div style={infoRow}>
                            <span style={infoLabel}>
                                <span className={'fa fa-briefcase'} style={{color: '#666', fontSize: 12}}/>
                                Project Name
                            </span>
                            <span style={infoValue}>{this.state.info.name || 'Not specified'}</span>
                        </div>
                        <div style={infoRow}>
                            <span style={infoLabel}>
                                <span className={'fa fa-info-circle'} style={{color: '#666', fontSize: 12}}/>
                                Description
                            </span>
                            <span style={infoValue}>{this.state.info.description || 'No description available'}</span>
                        </div>
                        <div style={infoRow}>
                            <span style={infoLabel}>
                                <span className={'fa fa-money'} style={{color: '#666', fontSize: 12}}/>
                                Budget
                            </span>
                            <span style={infoValue}>{this.state.info.budget || 'Not specified'}</span>
                        </div>
                    </div>
                    
                    <div style={infoCard}>
                        <div style={cardHeader}>
                            <span className={'fa fa-calendar'} style={{color: '#395d9a'}}/>Timeline
                        </div>
                        <div style={infoRow}>
                            <span style={infoLabel}>
                                <span className={'fa fa-calendar-plus-o'} style={{color: '#666', fontSize: 12}}/>
                                Registration Date
                            </span>
                            <span style={infoValue}>{this.state.info.reg_date || 'Not specified'}</span>
                        </div>
                        <div style={infoRow}>
                            <span style={infoLabel}>
                                <span className={'fa fa-calendar-check-o'} style={{color: '#666', fontSize: 12}}/>
                                Authorization Date
                            </span>
                            <span style={infoValue}>{this.state.info.auth_date || 'Not specified'}</span>
                        </div>
                        <div style={infoRow}>
                            <span style={infoLabel}>
                                <span className={'fa fa-flag'} style={{color: '#666', fontSize: 12}}/>
                                Status
                            </span>
                            <span style={{
                                ...statusBadge,
                                backgroundColor: this.state.info.status === 'Approved' ? '#d4edda' : 
                                               this.state.info.status === 'Rejected' ? '#f8d7da' : '#fff3cd',
                                color: this.state.info.status === 'Approved' ? '#155724' : 
                                       this.state.info.status === 'Rejected' ? '#721c24' : '#856404'
                            }}>{this.state.info.status || 'Pending'}</span>
                        </div>
                    </div>
                    
                    <div style={infoCard}>
                        <div style={cardHeader}>
                            <span className={'fa fa-map-marker'} style={{color: '#395d9a'}}/>Localities
                        </div>
                        {this.state.info.localities && this.state.info.localities.length > 0 ? (
                            this.state.info.localities.map((locality, i) => (
                                <div key={i} style={listItem}>
                                    <span className={'fa fa-map-pin'} style={{color: '#27ae60', fontSize: 12}}/>
                                    {locality.name}
                                </div>
                            ))
                        ) : (
                            <div style={emptyState}>
                                <span className={'fa fa-map-o'} style={{marginRight: 8}}/>
                                No localities assigned
                            </div>
                        )}
                    </div>
                    
                    <div style={infoCard}>
                        <div style={cardHeader}>
                            <span className={'fa fa-money'} style={{color: '#395d9a'}}/>Project Funders
                        </div>
                        {this.state.info.funders && this.state.info.funders.length > 0 ? (
                            this.state.info.funders.map((funder, i) => (
                                <div key={i} style={listItem}>
                                    <span className={'fa fa-building'} style={{color: '#3498db', fontSize: 12}}/>
                                    {funder.name}
                                </div>
                            ))
                        ) : (
                            <div style={emptyState}>
                                <span className={'fa fa-building-o'} style={{marginRight: 8}}/>
                                No funders assigned
                            </div>
                        )}
                    </div>
                </div>
                
                <div style={commentsCard}>
                    <div style={cardHeader}>
                        <span className={'fa fa-comments'} style={{color: '#395d9a'}}/>NLUPC Comments & Feedback
                    </div>
                            <textarea 
                        style={commentsTextarea}
                                readOnly={true} 
                                defaultValue={this.state.info.remarks}
                        placeholder="No comments available..."
                            />
                </div>
            </div>
        )
    }

}